import { useMemo } from 'react'

import { BUSINESS_CODE } from 'integration/resources/auth'
import { useAuthAtomValue } from 'src/store/auth'

export const useIsGoodsAndServices = (): boolean => {
  const authAtom = useAuthAtomValue()

  return useMemo(
    () => authAtom?.user.business_code === BUSINESS_CODE.GOODS_AND_SERVICES,
    [authAtom?.user.business_code]
  )
}
